import { USER_SESSION_KEY } from "../hooks/userSession";

// Reads the Cognito ID token captured at login (see useUserSession). Returns an
// empty string when there is no session so callers degrade gracefully.
const readIdToken = (): string => {
  const json = window.sessionStorage.getItem(USER_SESSION_KEY);
  if (!json) {
    return "";
  }
  try {
    return JSON.parse(json).idToken ?? "";
  } catch {
    return "";
  }
};

const LOGIN_PATH = "/employee/login";

// Drop-in replacement for fetch() that attaches the Cognito ID token as the
// Authorization header. Use it for endpoints protected by the API Gateway
// Cognito authorizer; leave public endpoints on plain fetch().
//
// On a 401 (expired/invalid token) or 403 (missing token) the session is cleared
// and the user is redirected to login. authFetch is a plain function, so it does a
// hard redirect rather than using react-router's navigate. No redirect loop: the
// login page authenticates via the Cognito SDK, not authFetch.
export const authFetch = async (input: RequestInfo | URL, init: RequestInit = {}) => {
  const idToken = readIdToken();
  const headers = new Headers(init.headers);
  if (idToken) {
    headers.set("Authorization", idToken);
  }

  const response = await fetch(input, { ...init, headers });

  if (response.status === 401 || response.status === 403) {
    window.sessionStorage.removeItem(USER_SESSION_KEY);
    window.location.assign(LOGIN_PATH);
  }

  return response;
};
